import React, {useState} from 'react'
import {FiChevronDown, FiChevronRight, FiDownload, FiFileText, FiLayers, FiList} from 'react-icons/fi'
import {useNavigate} from 'react-router-dom'
import {getPathWithPrefix} from 'utils/helper'
import {VmoMenu, VmoMenuItem, VmoAccordion, VmoAccordionContent, VmoAccordionTitle} from 'vmo-library'
import {ASSETS_PATH} from 'constants/path'

const AssetsMenu = () => {
  const navigate = useNavigate()

  const [activeIndexSettings, setActiveIndexSettings] = useState(true)

  return (
    <VmoMenu vertical secondary className="set-list">
      <VmoMenuItem
        active={window.location.pathname.includes(getPathWithPrefix(ASSETS_PATH.PREFIX, ASSETS_PATH.ALL))}
        onClick={() => navigate(getPathWithPrefix(ASSETS_PATH.PREFIX, ASSETS_PATH.ALL))}
      >
        <FiLayers /> All Assets
      </VmoMenuItem>

      <VmoAccordion>
        <VmoAccordionTitle onClick={() => setActiveIndexSettings(!activeIndexSettings)}>
          Settings
          {activeIndexSettings ? <FiChevronDown /> : <FiChevronRight />}
        </VmoAccordionTitle>
        <VmoAccordionContent active={activeIndexSettings}>
          <VmoMenuItem
            onClick={() => navigate(getPathWithPrefix(ASSETS_PATH.PREFIX, ASSETS_PATH.DEFAULT))}
            active={window.location.pathname.includes(getPathWithPrefix(ASSETS_PATH.PREFIX, ASSETS_PATH.DEFAULT))}
          >
            <FiList /> Default
          </VmoMenuItem>
          <VmoMenuItem
            onClick={() => navigate(getPathWithPrefix(ASSETS_PATH.PREFIX, ASSETS_PATH.FIELDS))}
            active={window.location.pathname.includes(getPathWithPrefix(ASSETS_PATH.PREFIX, ASSETS_PATH.FIELDS))}
          >
            <FiFileText /> Fields
          </VmoMenuItem>

          <VmoMenuItem
            onClick={() => navigate(getPathWithPrefix(ASSETS_PATH.PREFIX, ASSETS_PATH.IMPORT))}
            active={window.location.pathname.includes(getPathWithPrefix(ASSETS_PATH.PREFIX, ASSETS_PATH.IMPORT))}
          >
            <FiDownload /> Import
          </VmoMenuItem>
        </VmoAccordionContent>
      </VmoAccordion>
    </VmoMenu>
  )
}

export default AssetsMenu
